export var EComponent = /*#__PURE__*/function (EComponent) {
  EComponent["Accordion"] = "Accordion";
  EComponent["Attachment"] = "Attachment";
  EComponent["Button"] = "Button";
  EComponent["Carousel"] = "Carousel";
  EComponent["Divider"] = "Divider";
  EComponent["Default"] = "Default";
  EComponent["Faq"] = "Faq";
  EComponent["FullScreenImage"] = "FullScreenImage";
  EComponent["Images"] = "Images";
  EComponent["KnowledgeMatch"] = "KnowledgeMatch";
  EComponent["KnowledgeSingleChoice"] = "KnowledgeSingleChoice";
  EComponent["List"] = "List";
  EComponent["MultiColumnImageAndText"] = "MultiColumnImageAndText";
  EComponent["Quote"] = "Quote";
  EComponent["Tabs"] = "Tabs";
  EComponent["Text"] = "Text";
  EComponent["TextBesideImage"] = "ImageAndText";
  EComponent["TextButton"] = "TextButton";
  EComponent["TextOnImage"] = "TextOnImage";
  EComponent["Video"] = "Video";
  EComponent["YoutubePlayer"] = "YoutubePlayer";
  EComponent["Notice"] = "Notice";
  EComponent["ListImageAndTextDialog"] = "ListImageAndTextDialog";
  EComponent["MultiColumnImageAndLink"] = "MultiColumnImageAndLink";
  EComponent["LearningPathway"] = "LearningPathway";
  EComponent["SpecialProgram"] = "SpecialProgram";
  return EComponent;
}({});
export var TagType = /*#__PURE__*/function (TagType) {
  TagType["all"] = "all";
  TagType["selected"] = "selected";
  TagType["text"] = "text";
  TagType["image"] = "image";
  TagType["multiMedia"] = "multi-media";
  TagType["interactive"] = "interactive";
  TagType["knowledgeCheck"] = "knowledge-check";
  TagType["divider"] = "divider";
  TagType["knowledge"] = "knowledge";
  TagType["homePage"] = "homePage";
  return TagType;
}({});
export var TemplateTags = [{
  label: 'All',
  value: TagType.all
}, {
  label: 'Selected',
  value: TagType.selected
}, {
  label: 'Text',
  value: TagType.text
}, {
  label: 'Image',
  value: TagType.image
}, {
  label: 'Multi Media',
  value: TagType.multiMedia
}, {
  label: 'Interactive',
  value: TagType.interactive
}, {
  label: 'Divider',
  value: TagType.divider
}, {
  label: 'Knowledge',
  value: TagType.knowledge
}
// { label: 'HomePage', value: TagType.homePage },
];
export var TemplateTagsMap = TemplateTags.reduce(function (prev, item) {
  prev[item.value] = item;
  return prev;
}, {});